module.exports = __webpack_public_path__ + "static/media/recieve_msg.088295e3.mp3";